/* __next_internal_client_entry_do_not_use__ SDUIBannerCTARenderer auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spacer } from "@faire/web--source/slate/spacing";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
import { AppDownload } from "@faire/retailer/components/MobileAppPromoBanner/AppDownload";
import { DesktopAppDownloadPhoneInputForm } from "@faire/retailer/components/MobileAppPromoBanner/AppDownloadPromoBanner";
export var SDUIBannerCTARenderer = function(param) {
    var bannerComponent = param.bannerComponent;
    var CTAElementComponent = getCTAElementRenderer(bannerComponent);
    if (CTAElementComponent === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(CTAElementComponent, {})
        ]
    });
};
var getCTAElementRenderer = function(bannerElement) {
    if (bannerElement.app_download_phone_input_c_t_a_element) {
        return SDUIBannerAppDownloadPhoneInputCTA;
    }
    return undefined;
};
var SDUIBannerAppDownloadPhoneInputCTA = function() {
    return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        tabletAndBelow: /*#__PURE__*/ _jsx(AppDownload, {
            noModal: true
        }),
        desktopAndAbove: /*#__PURE__*/ _jsx(DesktopAppDownloadPhoneInputForm, {})
    });
};
